import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedComprobantesAgregarFormularioPdfComponent {
  agregando = false
  editable
  data
  onChange
  onDelete
  src = null

  constructor ($fileSystem, ViaticosViaticoComprobantesDocumentosArchivoService) {
    this.$fileSystem = $fileSystem
    this.ViaticosViaticoComprobantesDocumentosArchivoService = ViaticosViaticoComprobantesDocumentosArchivoService
  }

  generarLink () {
    if (!this.data) return

    this.src = this.ViaticosViaticoComprobantesDocumentosArchivoService.link(this.data.archivo_id)
  }

  seleccionar () {
    if (!this.editable) return
    this.$fileSystem.select(false, '.pdf')
      .then((files) => (this.agregar(files)))
  }

  agregar (files) {
    if (this.agregando) return

    this.agregando = true
    this.data = {
      archivo_id: null,
      name: files[0].name,
      file: files[0],
    }
    this.agregando = false

    this.onChange({$event: {detail: this.data}})
  }

  eliminar () {
    this.onDelete()
  }
}

module.component('viaticosSharedComprobantesAgregarFormularioPdf', {
  controller: ViaticosSharedComprobantesAgregarFormularioPdfComponent,
  template,
  bindings: {
    editable: '<',
    data: '<',
    pdf: '<',
    onChange: '&',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/comprobantes/agregar/formulario/pdf/component.js